import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const CUSTOMIZATION_OPTIONS = [
    'Show Principle Flow',
    'Show Principle Direction',
    'Show Item on Top',
    'Show Item Below Display'
];

export default function WizardSelectCustomizationForm({ principleData, actualPrinciplesData, peopleDetailsData, onDataChange, initialData }) {
    const [selectedCustomizations, setSelectedCustomizations] = useState(initialData.selectedCustomizations || []);
    const [principleText, setPrincipleText] = useState(initialData.principleText || '');
    const onDataChangeRef = useRef(onDataChange);

    // Check if "Show Derived Principle" is selected
    const isShowDerivedPrinciple = principleData?.selectedPrinciple === 'Show Derived Principle';

    // Update ref when callback changes
    useEffect(() => {
        onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    // Only call onDataChange when actual data changes, not when callback changes
    useEffect(() => {
        if (onDataChangeRef.current) {
            if (isShowDerivedPrinciple) {
                onDataChangeRef.current({ principleText });
            } else {
                onDataChangeRef.current({ selectedCustomizations });
            }
        }
    }, [selectedCustomizations, principleText, isShowDerivedPrinciple]);

    const handleToggleCustomization = (option) => {
        setSelectedCustomizations(prev => {
            if (prev.includes(option)) {
                return prev.filter(c => c !== option);
            } else {
                return [...prev, option];
            }
        });
    };

    const handleTextChange = (value) => {
        setPrincipleText(value);
    };

    return (
        <div className="wizard-select-customization-form">
            <h2 className="wizard-step-heading">
                {isShowDerivedPrinciple ? 'Type Principle' : 'Select Customization'}
            </h2>
            {isShowDerivedPrinciple ? (
                <div className="customization-text-editor">
                    <ReactQuill
                        className="wizard-quill"
                        theme="snow"
                        value={principleText}
                        onChange={handleTextChange}
                        placeholder="Type here"
                    />
                </div>
            ) : (
                <div className="customization-options">
                    {CUSTOMIZATION_OPTIONS.map((option, index) => (
                        <div
                            key={index}
                            className={`customization-option ${selectedCustomizations.includes(option) ? 'selected' : ''}`}
                            onClick={() => handleToggleCustomization(option)}
                        >
                            <div className="customization-option-content">
                                <span className="customization-label">{option}</span>
                                <input
                                    type="checkbox"
                                    checked={selectedCustomizations.includes(option)}
                                    onChange={() => handleToggleCustomization(option)}
                                    className="customization-checkbox"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
